// @ts-nocheck
import { createIcon } from "@chakra-ui/react";

const ChevronUpLine = createIcon({
  displayName: "ChevronUpLine",
  viewBox: "0 0 16 16",
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M 2.36 4.232 C 2.784 3.878 3.415 3.936 3.768 4.36 L 8 9.438 L 12.232 4.36 C 12.585 3.936 13.216 3.878 13.64 4.232 C 14.065 4.585 14.122 5.216 13.768 5.64 L 8.768 11.64 C 8.578 11.868 8.297 12 8 12 C 7.703 12 7.422 11.868 7.232 11.64 L 2.232 5.64 C 1.878 5.216 1.936 4.585 2.36 4.232 Z"
      fill="currentColor"
      transform="matrix(-1, 0, 0, -1, 16, 16)"
    />
  )
});

export default ChevronUpLine;
